import { render, staticRenderFns } from "./SubmitOfferDescriptionWindow.vue?vue&type=template&id=f865a216&scoped=true&"
import script from "./SubmitOfferDescriptionWindow.vue?vue&type=script&lang=js&"
export * from "./SubmitOfferDescriptionWindow.vue?vue&type=script&lang=js&"
import style0 from "./SubmitOfferDescriptionWindow.vue?vue&type=style&index=0&id=f865a216&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f865a216",
  null
  
)

export default component.exports